<template>
  <div>
    <div class="row page-header">
      <div class="col text-center mt-md-5">
        <h2 class="mb-2 mt-5">Tools Portal</h2>
        <h5>8x8 Inc</h5>
      </div>
    </div>

    <div class="row justify-content-center mt-5" v-if="isAuthorizedToViewLinks">
      <div
          :class="[
          'col-xs-12 col-md-auto mr-lg-5 text-center icon-wrapper',
          { 'mr-md-5': !isSideNavOpen },
          { 'mr-md-2': isSideNavOpen },
        ]"
      >
        <router-link
            v-if="isSupportGroup"
            class="circleBase"
            :to="{ name: 'Unbind VMMS DID' }"
        >
          <ResetIcon
              :className="'pt-3'"
              :size="115"
              :color="'#A4B8D1'"
          ></ResetIcon>
          <h5 class="mt-4 circle-label">Unbind VMMS</h5>
        </router-link>
        <router-link
            v-else
            class="circleBase"
            :to="{ name: isThorGroup ? 'Send Mail' : 'BPS' }"
        >
          <template v-if="isThorGroup">
            <EmailCircleIcon :size="130" :color="'#A4B8D1'"></EmailCircleIcon>
            <h5 class="mt-4 circle-label">Send Mail</h5>
          </template>
          <template v-else>
            <UserGroupsPlusIcon
                :size="115"
                :color="'#A4B8D1'"
            ></UserGroupsPlusIcon>
            <h5 class="mt-4 circle-label">BPS</h5>
          </template>
        </router-link>
      </div>
      <div
          :class="[
          'col-xs-12 col-sm-6 col-md-auto mx-lg-5 text-center icon-wrapper',
          { 'mx-md-5': !isSideNavOpen },
          { 'mt-sm-5 mt-md-0': isSideNavOpen },
        ]"
      >
        <a
            href="#"
            class="circleBase"
            @click.prevent
            v-b-modal.modal-customer-lock
        >
          <UserHostIcon :size="115" :color="'#A4B8D1'"></UserHostIcon>
          <h5 class="mt-4 circle-label">Select customer</h5>
        </a>
      </div>
      <div
          :class="[
          'col-xs-12 col-sm-6 col-md-auto ml-lg-5 text-center icon-wrapper',
          { 'ml-md-5': !isSideNavOpen },
          { 'ml-md-2 mt-sm-5 mt-md-0 ': isSideNavOpen },
        ]"
      >
        <router-link
            class="circleBase"
            :to="{ name: isThorGroup ? 'Home' : 'Port Orders' }"
        >
          <template v-if="isThorGroup">
            <HomeIcon :size="115" :color="'#A4B8D1'"></HomeIcon>
            <h5 class="mt-4 circle-label">Home</h5>
          </template>
          <template v-else>
            <DeskPhoneIcon
                :className="'pt-3'"
                :size="110"
                :color="'#A4B8D1'"
            ></DeskPhoneIcon>
            <h5 class="mt-4 circle-label">Port Orders</h5>
          </template>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import includes from "lodash/includes";
import {
 TAP_HOME_LINKS, TAP_TOOLS_SUPPORT,
  TAP_TOOLS_THOR,
} from "@/react/services/rbac/groups";
import intersection from "lodash/intersection";

export default {
  name: "home",
  computed: {
    ...mapGetters(["getUser", "isSideNavOpen"]),
    isThorGroup() {
      return includes(this.getUser.groups, TAP_TOOLS_THOR);
    },
    isSupportGroup() {
      return includes(this.getUser.groups, TAP_TOOLS_SUPPORT);
    },
    isAuthorizedToViewLinks() {
      return intersection(this.getUser.groups,
        TAP_HOME_LINKS
      ).length > 0
    }
  }
};
</script>
